// utils.ts or inside NotificationsService
export function isBadgingSupported(): boolean {
    return 'setAppBadge' in navigator || 'clearAppBadge' in navigator;
  }
  